// JSON codec cho prefill query param. Framework-agnostic.

/// Encode object → URL-safe string. Dùng cho `?prefill=<encoded>` trong URL.
export function encodePrefill(args: unknown): string {
  return encodeURIComponent(JSON.stringify(args));
}

/// Decode query param string → object. Return null nếu missing hoặc parse fail.
export function decodePrefill(raw: string | undefined | null): unknown | null {
  if (!raw) return null;
  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch {
    return null;
  }
}
